let remove_element = (actionData) => {
    let $el = $(actionData.selector);
    $el.remove();
};
export default remove_element;